export default {
  servicesList: [],
};
